import { render, staticRenderFns } from "./StationDetails.vue?vue&type=template&id=4989c0e3&scoped=true&"
import script from "./StationDetails.vue?vue&type=script&lang=js&"
export * from "./StationDetails.vue?vue&type=script&lang=js&"
import style0 from "./StationDetails.vue?vue&type=style&index=0&id=4989c0e3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4989c0e3",
  null
  
)

export default component.exports